module.exports = "/img/_/_/_/assets/images/creeper/book/rare//3.jpg?057c28dae91795023a774b0ef4201ddb";